import { createFileRoute } from '@tanstack/react-router';
import { Layout } from '@/pages/layout';

export const Route = createFileRoute('/admin/_layout')({
  component: Layout,
});
